// Shared Firebase ID-token helper.
//
// `UserContext` snapshots `accessToken` onto the user object it puts in React
// state, and that snapshot is never refreshed while the SPA stays mounted.
// Firebase ID tokens expire after an hour, so any request that reuses the
// snapshot starts failing `verifyIdToken` on the backend once the tab has been
// open a while. Those failures are swallowed by the service layer, so the page
// just renders empty data (e.g. a table of contents stuck at 0% progress) until
// the user reloads and auth state is re-established.
//
// `getIdToken()` returns the cached token when it is still valid and silently
// refreshes it when it is not, so calling it per-request is cheap.
import { auth } from "../config/firebase-config";

export const getFreshIdToken = async (fallbackToken = null) => {
  try {
    if (auth.currentUser) {
      return await auth.currentUser.getIdToken();
    }
  } catch (error) {
    console.error("Failed to refresh Firebase ID token:", error);
  }
  // No SDK user yet (mid sign-in, or a user object set by hand) — fall back to
  // whatever the caller already had.
  return fallbackToken;
};
